import React, { useEffect, useState, useCallback } from "react";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

function SalesReport() {
  const [sales, setSales] = useState([]);
  const [agents, setAgents] = useState([]);

  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [agentId, setAgentId] = useState("");

  // Load agents for filter dropdown
  const loadAgents = async () => {
    const res = await fetch(`${API_BASE}/agents`, {
      headers: authHeaders(),
    });
    const data = await res.json();
    setAgents(Array.isArray(data) ? data : []);
  };

  // Load sales report with filters
  const loadSales = useCallback(async () => {
  let url = `${API_BASE}/reports/sales?`;

  if (start) url += `start=${start}&`;
  if (end) url += `end=${end}&`;
  if (agentId) url += `agent_id=${agentId}&`;

  const res = await fetch(url, {
    headers: authHeaders(),
  });

  const data = await res.json();
  setSales(Array.isArray(data) ? data : []);
}, [start, end, agentId]);

  useEffect(() => {
  loadAgents();
}, []);

useEffect(() => {
  loadSales();
}, [loadSales]);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Sales Report</h2>

      {/* Filters */}
      <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
        
        <div>
          <label>Start Date</label><br />
          <input 
            type="date" 
            value={start} 
            onChange={(e) => setStart(e.target.value)} 
          />
        </div>

        <div>
          <label>End Date</label><br />
          <input 
            type="date" 
            value={end} 
            onChange={(e) => setEnd(e.target.value)} 
          />
        </div>

        <div>
          <label>Agent</label><br />
          <select 
            value={agentId} 
            onChange={(e) => setAgentId(e.target.value)}
          >
            <option value="">All Agents</option>
            {agents.map((a) => (
              <option key={a.id} value={a.id}>{a.name}</option>
            ))}
          </select>
        </div>

        <button 
          onClick={loadSales}
          style={{ padding: "6px 12px", background: "blue", color:"white", border:"none", borderRadius:"4px" }}
        >
          Apply Filters
        </button>
      </div>

      {/* Sales Table */}
      <table style={{ width:"100%", marginTop:"20px", borderCollapse:"collapse" }}>
        <thead>
          <tr style={{ background:"#ddd" }}>
            <th style={{ padding:"8px" }}>Bill ID</th>
            <th style={{ padding:"8px" }}>Customer</th>
            <th style={{ padding:"8px" }}>Agent</th>
            <th style={{ padding:"8px" }}>Items</th>
            <th style={{ padding:"8px" }}>Amount</th>
            <th style={{ padding:"8px" }}>Date</th>
          </tr>
        </thead>

        <tbody>
          {sales.map((s) => (
            <tr key={s.id} style={{ borderBottom:"1px solid #ccc" }}>
              <td style={{ padding:"8px" }}>{s.id}</td>
              <td style={{ padding:"8px" }}>{s.household}</td>
              <td style={{ padding:"8px" }}>{s.agent}</td>
              <td style={{ padding:"8px" }}>{s.total_items}</td>
              <td style={{ padding:"8px" }}>₹{s.total_amount}</td>
              <td style={{ padding:"8px" }}>
                {new Date(s.created_at).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}

export default SalesReport;
